import React, { FC } from "react";
import "./CustomSimpleCard.scss";
import { Box, Typography } from "@mui/material";
import CustomNetworkImage from "../CustomNetworkImage/CustomNetworkImage";
import { defaultEmptyFun } from "../../utils/helper";
import { useAppSelector } from "../../redux-store/CustomReduxHooks";

interface Props {
  useAlternateBannerImage: string;
  onClick?: any;
  style?: any;
}

const CustomSimpleBanner: FC<Props> = ({
  useAlternateBannerImage,
  onClick = defaultEmptyFun,
  style = {},
}) => {
  const isPseudoLoggedIn = useAppSelector(
    (st) => st.PseudoLoginSlice.isPseudoLoggedIn,
  );

  return (
    <Box
      className="custom-simple-banner"
      sx={{
        ...style,
        display: "inline-block",
        textAlign: "center",
        cursor: "pointer",
      }}
      onClick={!isPseudoLoggedIn ? onClick : undefined}
    >
      <img
        src={useAlternateBannerImage}
        alt=""
        style={{
          display: "inline-block",
          width: "100%",
          height: "100%",
        }}
      />
    </Box>
  );
};

export default CustomSimpleBanner;
